import { components } from '@/utils'

import items from '@/components/services/report-manager/queue/item/errors/items'

function renderHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.tab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.tab = event
        }
      }
    }
  )
}

function renderBody(h) {
  return h(
    items,
    {
      props: {
        data: this.value
      }
    }
  )
}

function renderTab(h, key) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--8 pa-2',
      props: {
        rounded: true,
        outline: true
      },
      key
    },
    [ renderBody.call(this, h) ]
  )
}

function renderContent(h) {
  return h(
    components.tabs,
    {
      props: { value: this.tab },
      scopedSlots: {
        body: () => {
          return this.tabs.map(tab => {
            return renderTab.call(this, h, tab.key)
          })
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
